import { render } from "./article-list.vue?vue&type=template&id=deb6ca0c&scoped=true&ts=true"
import script from "./article-list.vue?vue&type=script&lang=ts"
export * from "./article-list.vue?vue&type=script&lang=ts"

import "./article-list.vue?vue&type=style&index=0&id=deb6ca0c&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb6ca0c"]])

export default __exports__